export default __webpack_public_path__ + "static/media/logo_white.e852f3a6.svg";